module.exports = __webpack_public_path__ + "img/base militaire.e5bec0e6.png";